import "./Equipment.module.css";
import Header from "@/reusable_sections/Header";
import YourEquipmentSolutionStartsHere from "./sections/YourEquipmentSolutionStartsHere";
import OurEquipmentRange from "./sections/OurEquipmentRange";
import Footer from "@/reusable_sections/Footer";
export default function EquipmentPage() {
  return <div>
      <Header />
      <YourEquipmentSolutionStartsHere />
      <OurEquipmentRange />
      <Footer />
    </div>;
}